import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import {
  ServiceAvailabilityList,
  ServiceAvailabilityReadAllPaginatedRequestDTO,
  ServiceAvailabilityUpdateRequestDTO,
} from "./service-availability-interface";

import {
  ServiceAvailability_ReadAllPaginated,
  ServiceAvailability_Update,
} from "src/app/GlobalVariable";


@Injectable({
  providedIn: "root",
})
export class ServiceAvailabilityService {

  constructor(
    private http: HttpClient,
  ) {}


  // ============================================================
  // READ ALL PAGINATED
  // ============================================================

  readAllPaginated(
    request: ServiceAvailabilityReadAllPaginatedRequestDTO,
  ): Observable<ServiceAvailabilityList> {

    return this.http.post<ServiceAvailabilityList>(
      ServiceAvailability_ReadAllPaginated,
      request,
    );
  }


  // ============================================================
  // UPDATE
  // ============================================================

  update(
    request: ServiceAvailabilityUpdateRequestDTO,
  ): Observable<any> {

    return this.http.post<any>(
      ServiceAvailability_Update,
      request,
    );
  }

}